import React from 'react';
import { Table, Card, Popconfirm, Divider, message } from 'antd';
import { defaultPageSize, api, onGet, onPost } from '../../../../core/api3';
import { getUrlParam } from '../../../../utils/commonUtils';
import HuobiInvestmentEditModal from './HuobiInvestmentEditModal';
import moment from 'moment';

const { Column } = Table;

class HuobiInvestmentRecordCard extends React.Component {

    constructor() {
        super();
        this.state = {
            investments: [],
            pageNumber: 1,
            pageSize: defaultPageSize,
            totalPage: 0,
            totalRow: 0,
            modalVisible: false,
            investmentId: ''
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalFinish = this.onModalFinish.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let symbol = getUrlParam(this.props.location.search, 'symbol');
        onGet(api.listHuobiInvestment.url, api.listHuobiInvestment.params(symbol, this.state.pageNumber, this.state.pageSize)).then(response => {
            if (response === undefined) {
                return;
            }
            response.dataList.forEach(investment => {
                investment.key = investment.id;
                investment.typeStr = investment.type === 1 ? '买入' : '卖出';
                investment.price = investment.price + 'USDT';
                investment.volume = investment.volume + investment.symbol;
                investment.commission = investment.type === 1 ? investment.commission + investment.symbol : investment.commission + 'USDT';
                investment.totalPrice = investment.totalPrice + '元';
                investment.createTime = moment(investment.createTime * 1000).format('YYYY-MM-DD HH:mm');
            });
            this.setState({
                investments: response.dataList,
                totalPage: this.state.pageNumber,
                totalRow: response.dataSize
            });
        });
    }

    onClick(type, item) {
        switch (type) {
            case 'update':
                this.setState({ modalVisible: true, investmentId: item.key });
                break;
            case 'delete':
                onPost(api.deleteHuobiInvestment.url, api.deleteHuobiInvestment.params(item.key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('删除成功');
                    this.loadData();
                });
                break;
            default:
                break;
        }
    }

    onModalClose() {
        this.setState({ modalVisible: false });
    }

    onModalFinish() {
        this.setState({ modalVisible: false }, () => {
            this.loadData();
        });
    }

    onChangePage(pageNumber) {
        this.setState({ pageNumber: pageNumber }, () => {
            this.loadData();
        });
    }


    render() {
        return (
            <div>
                <Card title="定投记录" bordered={false} >
                    <Table dataSource={this.state.investments} pagination={{
                        current: this.state.pageNumber, total: this.state.totalRow, defaultPageSize: this.state.pageSize,
                        onChange: pageNumber => { this.onChangePage(pageNumber) }
                    }}>
                        <Column title="定投币种" dataIndex="symbol" align="center" />
                        <Column title="定投方向" dataIndex="typeStr" align="center" />
                        <Column title="交易单价" dataIndex="price" align="center" />
                        <Column title="交易数量" dataIndex="volume" align="center" />
                        <Column title="交易手续费" dataIndex="commission" align="center" />
                        <Column title="定投金额" dataIndex="totalPrice" align="center" />
                        <Column title="定投时间" dataIndex="createTime" align="center" />
                        <Column title="操作" align="center" render={item => (
                            <span>
                                <a onClick={() => this.onClick('update', item)} >编辑</a>
                                <Divider type="vertical" hidden={item.status === 3 || item.status === 4} />
                                <Popconfirm title="确定要删除这条记录？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('delete', item)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )} />
                    </Table>
                </Card>
                {this.state.modalVisible &&
                    <HuobiInvestmentEditModal isAdd={false} investmentId={this.state.investmentId} onModalCancel={this.onModalClose} onModalFinish={this.onModalFinish} />
                }
            </div>
        );
    }

}

export default HuobiInvestmentRecordCard;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/huobi/HuobiInvestmentRecordCard.jsx